<template lang="pug">
	.multi-select-dropdown(v-show="showed" :style="position" v-pseudo-modal-name="'multi-select-dropdown'")
		MultiLevelDropdownMenu(ref="dropdownMenu" @change="change($event.item, $event.data)" :width="width" :height="height" :header="header")
</template>

<script>
	import Screen from './../../../mixins/screen'

	import MultiLevelDropdownMenu from './../../UI/MultiLevelDropdownMenu'

	export default {
		name: 'MultiSelectDropdown',
		mixins: [Screen],
		screen: {
			updateOn: [],
			events: {
				"Show MultiSelectDropdown": function(el, items, options) {

					this.items = items;
					this.value = options.value;
					this.width = options.width || 200;
					this.height = options.height || null;
					this.header = options.header || null;
					this.callback = options.callback;

					let rect = el.getBoundingClientRect();

					this.position.right = (document.body.clientWidth - rect.right) + 'px';
					this.position.bottom = (document.body.clientHeight - rect.bottom) + 'px';

					this.update();

				},
				"Update MultiSelectDropdown": function(value) {

					this.value = value;

					this.update();

				},
				// Клик в любом месте кроме контента помеченного multi-select-dropdown - закрывает компонент
				"Pseudo Modal Process Hide": function(names) {

					if (!_.includes(names, 'multi-select-dropdown') && this.showed) {

						this.close();

					}

				}
			}
		},
		components: {
			MultiLevelDropdownMenu
		},
		props: [],
		data() {

			this.value = [];
			this.items = [];

			this.callback = null;
			this.width = 200;
			this.height = null;
			this.header = null;

			return {
				position: {
					right: 0,
					bottom: 0
				}
			};

		},
		methods: {
			collectData() {

				_.each(this.items, item => {

					if (this.value.includes(item?.data?.itemValue)) item.icon = 'fa-check';
					else item.icon = null;

				});

				if (this.$refs.dropdownMenu) this.$refs.dropdownMenu.setItems(this.items);

			},
			change(item, data) {

				this.callback(data);

			},
			close() {

				if (this.$refs.dropdownMenu) this.$refs.dropdownMenu.close();

				this.hide();

			}
		}
	}
</script>

<style lang="sass">

	.multi-select-dropdown
		position: absolute
		margin-top: 1px
		user-select: none

		.multi-level-dropdown-menu

			.mldm-item-title

				.fa
					color: var(--primary)

</style>
